"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.addErrorListener = exports.initLogger = void 0;
var zerg_1 = __importDefault(require("zerg"));
var transports_1 = require("zerg/dist/transports");
var logger = zerg_1.default.createLogger('@yeobill/chat');
var transportToConsole = zerg_1.default.createListener({
    handler: transports_1.consoleBrowserColorful,
});
exports.default = logger;
function initLogger() {
    logger.removeListener(transportToConsole);
    logger.addListener(transportToConsole);
}
exports.initLogger = initLogger;
function addErrorListener(handler) {
    var errorListener = zerg_1.default.createListener({
        handler: handler,
        levels: ['error'],
    });
    logger.addListener(errorListener);
}
exports.addErrorListener = addErrorListener;
//# sourceMappingURL=index.js.map